import { type FC, useContext } from 'react'
import { type IntlShape, useIntl } from 'react-intl'

import { FormHelperText } from 'base-ui'

import { RadioInput, type RadioParams } from '../../../base-form-handling'
import { useGlobalConfigContext } from '../../../global-config'
import { TENANT } from '../../../tenant'
import { LoginRegistrationRegistrationFormStateContext } from '../../context/LoginRegistrationRegistrationFormStateContext'

const TENANTS_WITH_DIVERSE_UNSPECIFIED_SALUTATIONS = new Set([
  TENANT.AT,
  TENANT.COM,
  TENANT.IT,
])

const getSalutations = (tenant: TENANT, intl: IntlShape): RadioParams[] => {
  const salutations: RadioParams[] = [
    {
      dataQaId: 'register-form-salutation-female',
      id: 'salutation_female',
      label: `${intl.formatMessage({
        id: 'general.label.salutation.mrs',
      })}*`,
      value: 'mrs',
    },
    {
      dataQaId: 'register-form-salutation-male',
      id: 'salutation_male',
      label: `${intl.formatMessage({ id: 'general.label.salutation.mr' })}*`,
      value: 'mr',
    },
  ]
  if (TENANTS_WITH_DIVERSE_UNSPECIFIED_SALUTATIONS.has(tenant)) {
    salutations.push(
      {
        dataQaId: 'register-form-salutation-diverse',
        id: 'salutation_diverse',
        label: `${intl.formatMessage({ id: 'general.label.salutation.diverse' })}*`,
        value: 'diverse',
      },
      {
        dataQaId: 'register-form-salutation-unspecified',
        id: 'salutation_unspecified',
        label: `${intl.formatMessage({ id: 'general.label.salutation.unspecified' })}*`,
        value: 'unspecified',
      },
    )
  }

  return salutations
}

export const LoginRegistrationSalutation: FC = () => {
  const intl = useIntl()
  const { tenant } = useGlobalConfigContext()
  const salutationRadios = getSalutations(tenant, intl)
  const { registrationFormState } = useContext(
    LoginRegistrationRegistrationFormStateContext,
  )
  const { model } = registrationFormState
  const error = model.validator.getFirstErrorFor('salutation')

  return (
    <div className="mb-1 flex flex-col">
      <fieldset className="flex flex-row flex-wrap gap-5">
        {salutationRadios.map((entry) => {
          return (
            <RadioInput
              checked={model.salutation === entry.value}
              dataQaId={entry.dataQaId}
              id={entry.id}
              key={entry.id}
              label={entry.label}
              name="salutation"
              onChange={(event) => {
                registrationFormState.setValue(
                  event.target.value,
                  model,
                  'salutation',
                )
              }}
              type="radio"
              value={entry.value}
            />
          )
        })}
      </fieldset>
      {error ? <FormHelperText error>{error}</FormHelperText> : null}
    </div>
  )
}
